import _ from "lodash";
// import { ProductForm } from '@shopify/theme-product-form'

class ProductFormElement extends HTMLElement {
  constructor() {
    super();
    this.isCustomily = document
      .querySelector("product-main")
      .getAttribute("customily");
    this.isNoPreviewCustomily = document
      .querySelector("product-main")
      .getAttribute("customily_no_preview");

    this.deactiveUnusedOptions = this.deactiveUnusedOptions.bind(this);

    if (this.dataset.variants) {
      this.variants = JSON.parse(this.dataset.variants);
    }
    this.gallery = document.querySelector("product-gallery");

    const formEl = this.querySelector("form");

    formEl.addEventListener("onOptionChange", (e) => {
      //console.log("[ProductForm] onOptionChange", e.detail);
      //console.log(e.target);
      this.deactiveUnusedOptions();
      if (e.target.hasAttribute("data-option")) {
        this.onOptionChange(e, "opt");
      }
    });

    formEl.addEventListener("change", (e) => {
      if (e.target.closest("[data-option]")) {
        this.onOptionChange(e, "sel");
      }
    });

    formEl.addEventListener("submit", (e) => {
      e.preventDefault();
      //console.log("[ProductForm] form submit");
      document.querySelector("shopify-cart").addItemFromForm(e.target);
    });

    if (this.isCustomily != "true" || this.isNoPreviewCustomily == "true") {
      if (
        this.gallery.querySelector(
          "div.image[attached-variant='" +
            this.querySelector('input[name="id"]').value +
            "']"
        )
      ) {
        this.gallery.ShowSelectedID(
          this.querySelector('input[name="id"]').value
        );
      } else {
        let selects = this.querySelectorAll("select[gallery_relevant]");
        if (selects) {
          //this.gallery.ShowSelectedType(selects[selects.length - 1].value);
        }
      }
    }
  }

  deactiveUnusedOptions() {
    // selectedOptions is an object like {option1: "18 KT Roségold", option2: "US 4.5 / EU 48"}
    let options = this.querySelectorAll("options-input");
    let opt1 = options[0]?.getAttribute("selected_id") || null;
    let opt2 = null;
    if (options.length > 2) {
      opt2 = options[1]?.getAttribute("selected_id") || null;
    }
    let opt3 = null;
    if (options.length > 3) {
      opt3 = options[2]?.getAttribute("selected_id") || null;
    }
    let selectedOptions = { option1: opt1, option2: opt2, option3: opt3 };
    //console.log("selectedOptions", selectedOptions);
    // Filter variants based on selected options
    const filteredVariantsForLevel2 = this.variants.filter((variant) => {
      return (
        !selectedOptions.option1 || variant.option1 === selectedOptions.option1
      );
    });

    const filteredVariantsForLevel3 = this.variants.filter((variant) => {
      return (
        (!selectedOptions.option1 ||
          variant.option1 === selectedOptions.option1) &&
        (!selectedOptions.option2 ||
          variant.option2 === selectedOptions.option2)
      );
    });

    // Extract valid options for each level based on filtered variants
    const validOptionsForLevel2 = {
      option1: [
        ...new Set(filteredVariantsForLevel2.map((variant) => variant.option1)),
      ],
      option2: [
        ...new Set(filteredVariantsForLevel2.map((variant) => variant.option2)),
      ],
      option3: [
        ...new Set(filteredVariantsForLevel2.map((variant) => variant.option3)),
      ],
    };

    const validOptionsForLevel3 = {
      option1: [
        ...new Set(filteredVariantsForLevel3.map((variant) => variant.option1)),
      ],
      option2: [
        ...new Set(filteredVariantsForLevel3.map((variant) => variant.option2)),
      ],
      option3: [
        ...new Set(filteredVariantsForLevel3.map((variant) => variant.option3)),
      ],
    };

    let validOptions = validOptionsForLevel2;
    //console.log("validOptionsForLevel2", validOptionsForLevel2);
    //console.log("validOptionsForLevel3", validOptionsForLevel3);

    // Deactivate options not in validOptions for each select element
    Array.from(options).forEach((option) => {
      if (option.getAttribute("data-place") == 1) {
        return;
      }
      if (option.getAttribute("data-place") == 3) {
        validOptions = validOptionsForLevel3;
      }
      Array.from(option.querySelectorAll(".opt")).forEach((optionElement) => {
        if (
          !validOptions["option" + option.getAttribute("data-place")].includes(
            optionElement.getAttribute("value")
          )
        ) {
          optionElement.setAttribute("aria-disabled", "true");
        } else {
          optionElement.removeAttribute("aria-disabled");
        }
      });
    });
  }

  backInStock(event) {
    event.preventDefault();
    let email_field = this.querySelector("#backinstockemail");
    let error_message = this.querySelector("#backinstockemail + .hidden");
    let button = this.querySelector("#backinstockemail ~ button");
    let email = email_field.value;
    let variant = this.querySelector("form").id.value;
    if (email == "") {
      // missing email
      error_message.classList.remove("hidden");
      return;
    }

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + variant,
            },
          },
        },
      },
    };

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2023-12-15",
      },
      body: JSON.stringify(payload),
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=VhnDTq",
      requestOptions
    ).then((response) => {
      if (response.status == 202) {
        error_message.classList.add("hidden");
        email_field.classList.add("send");
        email_field.classList.add("hidden");
        //subscribed
        button.classList.remove("btn-primary", "text-anna-gray");
        button.classList.add(
          "bg-white",
          "border",
          "border-black",
          "cursor-default",
          "text-anna-black"
        );
        button.setAttribute("onclick", "event.preventDefault();");
        button.setAttribute("disabled", "");
        if (window.location.pathname.includes("/en")) {
          button.innerHTML = "Notification active";
        } else {
          button.innerHTML = "Benachrichtigung aktiv";
        }
      }
      if (response.status == 400) {
        error_message.classList.remove("hidden");
      }
    });
  }

  onOptionChange(event, type) {
    const formEl = this.querySelector("form");
    //console.log("Change detected");

    let option1 = "";
    let option2 = "";
    let option3 = "";
    if (type == "opt") {
      option1 = formEl
        .querySelector('options-input[data-option="1"]')
        ?.getAttribute("selected_id");
      option2 = formEl
        .querySelector('options-input[data-option="2"]')
        ?.getAttribute("selected_id");
      option3 = formEl
        .querySelector('options-input[data-option="3"]')
        ?.getAttribute("selected_id");
    }
    if (type == "sel") {
      option1 = formEl.querySelector('select-input [data-option="1"]')?.value;
      option2 = formEl.querySelector('select-input [data-option="2"]')?.value;
      option3 = formEl.querySelector('select-input [data-option="3"]')?.value;
    }

    if (
      (this.isCustomily != "true" &&
        event.target.hasAttribute("gallery_relevant")) ||
      (this.isNoPreviewCustomily == "true" &&
        event.target.hasAttribute("gallery_relevant"))
    ) {
      this.gallery.ShowSelectedType(event.target.value || null);
    }

    /*console.log("option1", option1?.getAttribute("selected_id"));
    console.log("option2", option2?.getAttribute("selected_id"));
    console.log("option3", option3?.getAttribute("selected_id"));*/
    const matchingVariant = _.find(this.variants, {
      option1: option1 || null,
      option2: option2 || null,
      option3: option3 || null,
    });

    //console.log("matchingVariant", matchingVariant);

    if (this.isCustomily != "true" || this.isNoPreviewCustomily == "true") {
      if (
        this.gallery.querySelector(
          "[attached-variant*='" + matchingVariant.id + "']"
        )
      ) {
        this.gallery.ShowSelectedID(matchingVariant.id);
      } else if (event.target.hasAttribute("gallery_relevant")) {
        this.gallery.ShowSelectedType(event.target.value || null);
      }
    }

    if (matchingVariant) {
      //console.log("changed variant");
      this.querySelector('input[name="id"]').value = matchingVariant.id;

      window.Shopify.analytics.publish("pdp:variant_change", matchingVariant);

      this.dispatchEvent(
        new CustomEvent("change-variant", {
          detail: { id: matchingVariant.id },
          bubbles: true,
        })
      );
    }
  }
}

customElements.define("product-form", ProductFormElement);
